<template>
    <div id="app">
        <div v-if="loading" class="full-loading">
            <app-loader />
        </div>

        <component :is="layout" v-if="!loading">
            <router-view :key="$route.path"></router-view>
        </component>
    </div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	import LayoutDefault from "./layouts/Default.vue";
	import LayoutAuth from "./layouts/Auth.vue";
	import Loader from '@/components/Loader';
	import {
		DEFAULT_LAYOUT
	} from './constants/default.js';

	import '@/sass/tailwind.scss';

	export default {
		name: 'app',
		components: {
			'layout-default': LayoutDefault,
			'layout-auth': LayoutAuth,
			'app-loader': Loader
		},
		computed: {
			...mapGetters({
				loading: 'loading',
			}),
			layout() {
				return 'layout-' + (this.$route.meta.layout || DEFAULT_LAYOUT);
			}
		},
		methods: {
		},
		watch: {
			errors(data) {
				if(data.length > 0) {
					for(let key in data) {
						this.$toasted.show(data[key], {
							theme: "error",
							position: "top-center",
							duration : 5000
						});
					}
					this.updateErrors([]);
				}
			}
		}
	}
</script>

<style lang="scss">
	html, body, #app, .l-page {
		@apply .min-h-full .w-full .h-full;
	}

	.fs0 {
		font-size: 0;
	}

    .full-loading {
        position: fixed;
        top: 50%;
        right: 0;
        bottom: auto;
        left: 0;

        text-align: center;
        transform: translateY(-50%);

        .loading svg {
            width: 100px;
            height: 100px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue